import { useTranslation } from 'react-i18next';

import { Icon } from '@sternum/web/components';
import { ModeVariant } from '@sternum/web/features/appContainerWithMenu/models';
import { Mode } from '@sternum/web/features/client/models';
import { namespaces } from '@sternum/web/services/i18n';

import { Tag, TagForSandbox, TagForTrial, TextForTag } from './ModeTag.styles';

interface ModeTagProps {
  mode: Mode;
  variant?: ModeVariant;
}

export function ModeTag({ mode, variant }: ModeTagProps) {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  if (variant === 'trial' && mode === 'devices') {
    return (
      <TagForTrial aria-label="modeTag">
        <Icon
          type="RouterIcon"
          size={9}
          color={{
            Dark: 'BlueDark',
            Light: 'BlueDark',
          }}
        />

        <TextForTag>{t('modeTag.iotTrial')}</TextForTag>
      </TagForTrial>
    );
  }

  if (variant === 'sandbox') {
    return (
      <TagForSandbox aria-label="modeTag">
        <Icon
          type="CodeSandboxCubeIcon"
          color={{
            Dark: 'OrangeDarkest',
            Light: 'OrangeDarkest',
          }}
          size={9}
        />

        <TextForTag>{t('modeTag.iotSandbox')}</TextForTag>
      </TagForSandbox>
    );
  }

  if (mode === 'devices') {
    return (
      <Tag aria-label="modeTag">
        <Icon type="RouterIcon" size={9} />

        <TextForTag>{t('modeTag.devices')}</TextForTag>
      </Tag>
    );
  }

  if (mode === 'compute') {
    return (
      <Tag aria-label="modeTag">
        <Icon type="ServerIcon" size={9} />

        <TextForTag>{t('modeTag.compute')}</TextForTag>
      </Tag>
    );
  }
}
